import React, { useCallback, useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import '../../App.css';
import { CustomLogo, DoctorLogo } from '../../assets'
import { SImage, CardWithIcon, CardBasic, SButton, RangeDatePicker, Breadcrumb, PaginationCustom } from '../../components'
import NavDate from '../../components/NavDate';
import { useSelector } from 'react-redux';

function Dashboard() {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [dateRange, setDateRange] =  useState({
    startDate: new Date(),
    endDate: new Date(),
  });
  const user = useSelector((state) => state.auth);

  // Format tanggal sekarang (untuk tampilan header)
  const dayName = selectedDate.toLocaleDateString("en-US", { weekday: "short" });
  const dayTitle = selectedDate.getDate();
  const monthNow = selectedDate.toLocaleDateString("en-US", { month: "short" });
  const yearNow = selectedDate.getFullYear();
  
  const appointmentsData = [
    { id: 1,date: new Date(2025, 2, 9), time: "10:00 - 11:00 AM", name: "Annisa Gabriele Santosa", doctor: "dr. Narizka Rahmadhiani, AAAM" },
    { id: 2,date: new Date(2025, 2, 2), time: "10:00 - 11:00 AM", name: "Budi Setia Sasongko", doctor: "dr. Yovi Yoanita" },
    { id: 3,date: new Date(2025, 2, 9), time: "11:00 - 12:00 AM", name: "Hani Charisa Rahardja", doctor: "dr. Narizka Rahmadhiani, AAAM" },
    { id: 4,date: new Date(2025, 2, 9), time: "12:00 - 13:00 PM", name: "Ayu Widya", doctor: "dr. Andi Syamsul" },
    { id: 5,date: new Date(2025, 2, 9), time: "13:00 - 14:00 PM", name: "Ayu Shinta", doctor: "dr. Andi Syamsul" },
  ];

  const transactionData = [
    { id: 1, date: new Date(2025, 2, 9), patientName: "John Doe", total: 100, action: "View" },
    { id: 2, date: new Date(2025, 2, 9), patientName: "Jane Smith", total: 150, action: "View" },
    { id: 3, date: new Date(2025, 2, 9), patientName: "Emily Johnson", total: 200, action: "View" },
    { id: 4, date: new Date(2025, 2, 9), patientName: "Michael Brown", total: 250, action: "View" },
    { id: 5, date: new Date(2025, 2, 9), patientName: "Sarah White", total: 300, action: "View" },
    { id: 6, date: new Date(2025, 2, 9), patientName: "David Green", total: 350, action: "View" },
    { id: 7, date: new Date(2025, 2, 9), patientName: "Sophia Lee", total: 400, action: "View" },
    { id: 8, date: new Date(2025, 2, 9), patientName: "Daniel Kim", total: 450, action: "View" },
  ];

  const cardIncome = () => {
    return (
      <>
        <div className='d-flex border border-primary border-dashed rounded p-5 bg-light-primary mb-6'>
            <div className='me-2'>
              <span className='text-gray-700 fw-semibold d-block fs-5'>
                7 Juni 2024
              </span>
            </div>
        </div>
        <div className='d-flex mb-6'>
            <div className='me-2'>
              <span className='fw-bold d-block fs-6'>Rp. 57.890.500</span>
              <span className='text-gray-700 fw-semibold d-block fs-5'>Income this month</span>
            </div>
            <div className='mx-2'>
                <span className='badge badge-light-danger'>
                  <i className='ki-outline ki-arrow-down text-danger'></i>
                  72,8 %
                </span>
            </div>
        </div>
        <div className='d-block'>
          <div className='row'>
              <div className='col-4'>
                <span className='text-gray-700 fw-semibold fs-5'>Jan</span>
              </div>
              <div className='col-4'>
                <span className='text-black-700 fw-bold fs-7'>Rp. 303.756.000</span>
              </div>
              <div className='col-4'>
                <i className='ki-outline ki-plus text-success'></i>
                <span className='text-success'>1.34</span>
              </div>
          </div>
          <div className='row mt-2'>
              <div className='col-4'>
                <span className='text-gray-700 fw-semibold fs-5'>Feb</span>
              </div>
              <div className='col-4'>
                <span className='text-black-700 fw-bold fs-7'>Rp. 303.756.000</span>
              </div>
              <div className='col-4'>
                <i className='ki-outline ki-plus text-success'></i>
                <span className='text-success'>1.34</span>
              </div>
          </div>
          <div className='row mt-2'>
              <div className='col-4'>
                <span className='text-gray-700 fw-semibold fs-5'>March</span>
              </div>
              <div className='col-4'>
                <span className='text-black-700 fw-bold fs-7'>Rp. 303.756.000</span>
              </div>
              <div className='col-4'>
                <i className='ki-outline ki-plus text-success'></i>
                <span className='text-success'>1.34</span>
              </div>
          </div>
        </div>
      </>
    )
  }

  const cardCustomer = () => {
    return (
      <>
        <div className='mb-6'>
            <div className="fs-2hx fw-bold">13</div>
            <div className="fs-4 fw-semibold text-gray-400 mb-7">New Customers this month</div>
        </div>
        <div className='d-block'>
          <div className='row'>
              <div className='col-12'>
                <span className='text-black-700 fw-semibold fs-5'>Today's New Customers</span>
              </div>
              <div className='col-12'>
                <div className="symbol-group symbol-hover mb-9">
                    <div className="symbol symbol-35px symbol-circle" data-bs-toggle="tooltip" title="Alan Warden">
                      <span className="symbol-label bg-warning text-inverse-warning fw-bold">A</span>
                    </div>
                    <div className="symbol symbol-35px symbol-circle" data-bs-toggle="tooltip" title="Alan Warden">
                      <span className="symbol-label bg-success text-inverse-warning fw-bold">B</span>
                    </div>
                    <div className="symbol symbol-35px symbol-circle" data-bs-toggle="tooltip" title="Alan Warden">
                      <span className="symbol-label bg-danger text-inverse-warning fw-bold">C</span>
                    </div>
                    <div className="symbol symbol-35px symbol-circle" data-bs-toggle="tooltip" title="Alan Warden">
                      <span className="symbol-label bg-primary text-inverse-warning fw-bold">E</span>
                    </div>
                    <div className="symbol symbol-35px symbol-circle" data-bs-toggle="tooltip" title="Alan Warden">
                      <span className="symbol-label bg-info text-inverse-warning fw-bold">F</span>
                    </div>
                </div>
              </div>
            
              {/* <CardWithIcon
                className={'w-sm-50px h-sm-50px text-center align-items-center'}
                className2={'bg-secondary symbol rounded-3  d-flex align-items-center'}
                className5={'fw-bold fs-6 text-center'}
                child={'K'}
              /> */}
          </div>
        </div>
      </>
    )
  }

  const ListAppointment = ({appointments , setSelectedDate}) => {
    // const [selectedDate, setSelectedDate] = useState(new Date());
    const itemsPerPage = 2;
    const [filteredData, setFilteredData] = useState([]);
    const [newData, setNewData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);

    // const filteredAppointments = appointments.filter(
    //   (appointment) => 
    //     appointment.date.toDateString() === selectedDate.toDateString() 
    // );

    useEffect(() => {
      const filteredAppointments = appointments.filter(
        (appointment) => 
          appointment.date.toDateString() === selectedDate.toDateString() 
      );

      setLoading(true);
      setTimeout(() => {
          setFilteredData(filteredAppointments);
          setNewData(filteredAppointments);
          setCurrentPage(1);  // Reset halaman saat filter berubah
          setLoading(false);  // Hentikan loading setelah data tersedia
      }, 300); // Durasi loading (sesuai dengan durasi transisi)

    }, [setSelectedDate,appointments]);

    const handlePagination = useCallback((data) => {
      setFilteredData((prevData) => {
            // Hanya setState jika data berbeda
            if (JSON.stringify(prevData) !== JSON.stringify(data)) {
                // setCurrentPage(1);
                return data;
            }
            return prevData;
      });
    }, []);

    return (
      <>
        <NavDate selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
          <div>
          {filteredData.length > 0 ? (
              filteredData.map((appointment) => (
                <div className={`d-flex flex-stack position-relative mt-8 mb-8 ${loading ? 'hidden' : ''}`} key={appointment.id}>
                    <div className='position-absolute h-100 w-4px bg-primary rounded top-0 start-0'></div>
                    <div className='fw-semibold ms-5 text-gray-600'>
                        <div className='fs-5'><strong>{appointment.time}</strong>
                          <span className='fs-7 text-gray-400 text-uppercase'></span>
                        </div>
                        <span className='fs-5 fw-bold text-gray-800 text-hover-primary mb-2'>{appointment.name}</span>
                        <div className="text-gray-400">{appointment.doctor}</div>
                        <p>
                          <small>
                            <em>{appointment.date.toDateString()}</em>
                          </small>
                        </p>
                    </div>
                    <div className="btn btn-bg-light btn-active-color-primary btn-sm">View</div>
                </div>

              ))
            ) : (
              <div className='d-flex flex-stack position-relative mt-8 mb-8'>
                <span>No appointments available for the selected date.</span>
              </div>
            )
          }
            <PaginationCustom
                data={newData || []}
                page={itemsPerPage}
                current={currentPage}
                onPaginate={handlePagination}
                selectedDate={selectedDate}
            />
          </div>
      </>
    )
  }

  const CardHeaderTransaction = ({ dateRange , setDateRange}) => {
    return (
      <>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fs-3 fw-bold text-gray-800'>List Transaction</span>
          <span className='text-gray-400 mt-1 fw-semibold fs-6'>Select a campaign & date range to view data</span>
        </h3>
        <div className='card-toolbar'>
          <RangeDatePicker 
            selectedDate={dateRange}
            setSelectedDate={setDateRange}
          />
        </div>
      </>
    );
  }

  const ListTransaction = ({ transactions , dateRange}) => {
    const [filteredData, setFilteredData] = useState([]);
    const [newData, setNewData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const itemsPerPage = 3;
    

    useEffect(() => {
      const filtered = transactions.filter((item) => {
        const itemDate = new Date(item.date);
        const startDate = new Date(dateRange.startDate);
        const endDate = new Date(dateRange.endDate);
        
        return itemDate >= startDate && itemDate <= endDate;
      });
      setLoading(true);
      setTimeout(() => {
          setFilteredData(filtered);
          setNewData(filtered);
          setCurrentPage(1);  // Reset halaman saat filter berubah
          setLoading(false);  // Hentikan loading setelah data tersedia
      }, 300); // Durasi loading (sesuai dengan durasi transisi)

      setCurrentPage(1);
    }, [dateRange, transactions]);


    const handlePagination = useCallback((data) => {
      setFilteredData((prevData) => {
            // Hanya setState jika data berbeda
            if (JSON.stringify(prevData) !== JSON.stringify(data)) {
                // setCurrentPage(1);
                return data;
            }
            return prevData;
      });
    }, []);
 
    return (
      <>   
        <div className='table-responsive'>
          <table className={`table table-row-dashed align-middle gs-0 gy-6 my-0 ${loading ? 'hidden' : ''}`}>
            <thead>
              <tr className='fs-7 fw-bold text-gray-400'>
                <th className=''>Date</th>
                <th className=''>Patient Name</th>
                <th className=''>Total</th>
                <th className='p-0 pb-3 w-50px text-end'>Action</th>
              </tr>
            </thead>
            <tbody>
            {
             filteredData.length > 0 ? 
              filteredData.map((transaction) => (
                    <tr key={transaction.id}>
                      <td>{transaction.date.toDateString()}</td>
                      <td>{transaction.patientName}</td>
                      <td>{transaction.total}</td>
                      <td>
                        <button className="btn btn-primary">{transaction.action}</button>
                      </td>
                    </tr>
              )) : (
                <tr>
                  <td colSpan={'4'}>No transaction available for the selected date.</td>
                </tr>
              )
            }
            </tbody>
          </table>
          <PaginationCustom
              data={newData || []}
              page={itemsPerPage}
              current={currentPage}
              onPaginate={handlePagination}
          />
        </div>
      </>
    )
  }
  
  return (
    <>
      <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
        <Breadcrumb title={'Home'} header={'Dashboard'}/>
        <div className='app-container container-xxl d-flex'>
          <div className='app-main flex-column flex-row-fluid' id="kt_app_main">
            <div className='d-flex flex-column flex-column-fluid'>
                <div className='app-content'>
                    <div className='row g-5 g-xxl-10'>
                      <div className='col-xxl-4 mb-xxl-10'>
                         <Card className='card-reset mb-5 mb-xl-10'>
                            <Card.Body className='p-0'>
                              <div className='row g-5 g-lg-9'>
                                  <div className='col-6'>
                                    <CardWithIcon
                                      className={'card-shadow'}
                                      className2={'p-0'}
                                      className3={'btn btn-active-color-primary px-7 py-6 text-start w-100'}
                                      className4={'ki-outline ki-home fs-2x fs-lg-2hx text-gray-500 ms-n1'}
                                      className5={'fw-bold fs-5 pt-4'}
                                      link={'/dashboard'}
                                      child={'Dashboard'}
                                    />
                                  </div>
                                  <div className='col-6'>
                                    <CardWithIcon
                                      className={'card-shadow'}
                                      className2={'p-0'}
                                      className3={'btn btn-active-color-primary px-7 py-6 text-start w-100'}
                                      className4={'ki-outline ki-people fs-2x fs-lg-2hx text-gray-500 ms-n1'}
                                      className5={'fw-bold fs-5 pt-4'}
                                      link={'/patient'}
                                      child={'Data Patient'}
                                    />
                                  </div>
                                  <div className='col-6'>
                                    <CardWithIcon
                                        className={'card-shadow'}
                                        className2={'p-0'}
                                        className3={'btn btn-active-color-primary px-7 py-6 text-start w-100'}
                                        className4={'ki-outline ki-notepad-edit fs-2x fs-lg-2hx text-gray-500 ms-n1'}
                                        className5={'fw-bold fs-5 pt-4'}
                                        link={'/appointment'}
                                        child={'Appointment Patient'}
                                    />
                                  </div>
                                  <div className='col-6'>
                                      <CardWithIcon
                                        className={'card-shadow'}
                                        className2={'p-0'}
                                        className3={'btn btn-active-color-primary px-7 py-6 text-start w-100'}
                                        className4={'ki-outline ki-abstract-14 fs-2x fs-lg-2hx text-gray-500 ms-n1'}
                                        className5={'fw-bold fs-5 pt-4'}
                                        link={'/registration'}
                                        child={'Registration Patient'}
                                      />
                                  </div>
                                  <div className='col-6'>
                                      <CardWithIcon
                                        className={'card-shadow'}
                                        className2={'p-0'}
                                        className3={'btn btn-active-color-primary px-7 py-6 text-start w-100'}
                                        className4={'ki-outline ki-shop fs-2x fs-lg-2hx text-gray-500 ms-n1'}
                                        className5={'fw-bold fs-5 pt-4'}
                                        link={'/product'}
                                        child={'Product'}
                                      />
                                  </div>
                                  <div className='col-6'>
                                      <CardWithIcon
                                        className={'card-shadow'}
                                        className2={'p-0'}
                                        className3={'btn btn-active-color-primary px-7 py-6 text-start w-100'}
                                        className4={'ki-outline ki-capsule fs-2x fs-lg-2hx text-gray-500 ms-n1'}
                                        className5={'fw-bold fs-5 pt-4'}
                                        link={'google.com'}
                                        child={'Pharmacy'}
                                      />
                                  </div>
                                  <div className='col-6'>
                                      <CardWithIcon
                                        className={'card-shadow'}
                                        className2={'p-0'}
                                        className3={'btn btn-active-color-primary px-7 py-6 text-start w-100'}
                                        className4={'ki-outline ki-cheque fs-2x fs-lg-2hx text-gray-500 ms-n1'}
                                        className5={'fw-bold fs-5 pt-4'}
                                        link={'/pos'}
                                        child={'Cashier'}
                                      />
                                  </div>
                                  <div className='col-6'>
                                      <CardWithIcon
                                        className={'card-shadow'}
                                        className2={'p-0'}
                                        className3={'btn btn-active-color-primary px-7 py-6 text-start w-100'}
                                        className4={'ki-outline ki-menu fs-2x fs-lg-2hx text-gray-500 ms-n1'}
                                        className5={'fw-bold fs-5 pt-4'}
                                        link={'google.com'}
                                        child={'Report'}
                                      />
                                  </div>
                              </div>
                            </Card.Body>
                         </Card>
                         <CardBasic 
                            className={'border-0 mb-5'}
                            className2={'py-12'}
                            children={cardIncome()}
                         />
                         <CardBasic 
                          className={'border-0'}
                          className2={'py-12'}
                          children={cardCustomer()}
                         />
                      </div>
                      <div className='col-xxl-8 mb-5 mb-xl-10'>
                        <div className='card border-0 mb-5 mb-xl-11' data-bs-theme='light' style={{backgroundColor:'#844AFF'}}>
                            <div className='card-body'>
                              <div className='row align-items-center lh-1 h-100'>
                                <div className='col-7 ps-xl-10 pe-5'>
                                  <SImage
                                    alt={'logo'}
                                    source={CustomLogo}
                                    className={'mb-2'}
                                  />
                                  <span className='fs-2qx fw-bold text-white d-block mb-6'>
                                    Good Morning, {user.user.full_name}
                                  </span>
                                  <span className='fw-semibold text-white fs-6 mb-10 d-block opacity-75'>
                                    Stay enthusiastic about your activities today!
                                  </span>
                                </div>
                                <div className='col-5 pt-5 pt-lg-15'>
                                  <SImage
                                    alt={'logo'}
                                    source={DoctorLogo}
                                    className={'bgi-no-repeat bgi-size-contain bgi-position-x-end bgi-position-y-bottom h-325px'}
                                  />
                                </div>
                              </div>
                            </div>
                        </div>
                        <CardBasic
                          className={'border-0 mb-5 mb-xl-11 card-flush '}
                          children={<ListAppointment appointments={appointmentsData} setSelectedDate={setSelectedDate}/>}
                          className3={'mt-6'}
                          className2={'p-9 pt-4'}
                          header={
                            <>
                              <div className='col-6'>
                                <div className="card-title flex-column">
                                  <h3 className="fw-bold mb-1">Appointment</h3>
                                  <div className="fs-6 text-gray-400">{dayName}, {dayTitle} {monthNow} {yearNow}</div>
                                </div>
                              </div>
                              <div className='col-6'>
                                <div className="card-toolbar justify-content-end">
                                  <SButton className={'bg-secondary text-primary'} children={'Report'}/>
                                </div>
                              </div>
                            </>
                          }
                        />
                        <CardBasic
                          className={'card-flush border-0 mb-xl-11'}
                          header={<CardHeaderTransaction dateRange={dateRange}  setDateRange={setDateRange}/>}
                          className3={'pt-7'}
                          children={<ListTransaction transactions={transactionData} dateRange={dateRange}/>}
                        />
                      </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Dashboard